<template>
  <div class="home-div">
    <div class="home-head-position">
      <div style="width: 400px; display: flex; align-items: center; justify-content: space-between;">
        <div style="width: 250px; display: flex; justify-content: space-around; align-items: center;">
          <!-- <img src="../../../public/img/logoqunlun.png" style="width: 60px; height: 60px; margin-bottom: 10px;" alt=""> -->
          <!-- <img src="../../../public/img/logoqunlun.png" style="width: 160px; height: 80px;"> -->
                     <span style="width: 250px; font-size: 30px; font-weight: 500; color: #fff; line-height: 40px; text-align: center;" class="caa-logo">大国电子拍卖平台</span>
        </div>
        <div class="top-welcome">
          <span>欢迎登录</span>
        </div>
      </div>

      <div class="top-button cursor-pointer-div" @click="backHome">
        <img class="button-img" src="../../../public/img/backhome.png" alt="">
        <span class="button-span">返回首页</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loginHeadView',
  methods: {
    backHome() {
      this.$router.push("/");
    }
  }
}
</script>

<style scoped>
.cursor-pointer-div:hover {
  cursor: pointer;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.35);
}
.button-img {
  margin-left: 16px;
  margin-top: 11px;
  width: 17.5px;
  height: 17.47px;
  opacity: 1;
}
.button-span {
  display: inline-block;
  position: relative;
  margin-left: 5px;
  margin-top: 8px;
  width: 64px;
  height: 24px;
  opacity: 1;
  /** 文本1 */
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 23.17px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}
.top-button {
  position: relative;
  width: 120px;
  height: 40px;
  opacity: 1;
  border-radius: 6px;
  background: linear-gradient(
    135deg,
    rgba(0, 102, 166, 1) 0%,
    rgba(59, 133, 243, 1) 100%
  );
}
.top-welcome {
  position: relative;
  padding-left: 26px;
  width: 80px;
  height: 40px;
  opacity: 1;
  /** 文本1 */
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 40px;
  color: #fff;
  text-align: left;
  vertical-align: top;
  border-left: solid 1px #fff;

  /* width:500px;
    height:20px" */
}
.home-jzjdsbgy {
  z-index: 0;
  position: relative;
  top: 59px;
  width: 211px;
  height: 79px;
  opacity: 1;
}
.home-qlgs {
  z-index: 1;
  position: relative;
  width: 140px;
  height: 48.5px;
  opacity: 1;
}
.home-logo {
  position: relative;
  width: 200px;
  height: 80px;
  opacity: 1;
}
.home-div {
  width: 100%;
  z-index: 0;
  background-color: rgb(255, 255, 255);
  /* border-bottom: solid 3px rgba(102, 102, 102, 1); */
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.35);
}
.home-head-position {
  /* position: relative; */
  left: 500px;
  width: 100%;
  height: 100px;
  background-color: #014f80;
  z-index: -1;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.caa-logo{
  font-family: 'ALIMAMASHUHEITI' !important;
}
</style>